import React, { useContext } from 'react';
import PageContent from '../../Util/PageContent';
import { ProductDescription } from './ProductDescription';
import { ProductSpecificationsWrapper } from './ProductSpecifications';
import { MobileDrops } from './MobileDrops';
import { TabData } from './TabData';
import { styled } from 'linaria/react';
import GetStartPage from '../../StartPage/GetStartPage';
import TextContent from '../../ui/TextContent';
import { config } from '../../../shop.config.custom';
import { BrandTab } from './BrandTab';
import SiteContentContext from '../../SiteContent/SiteContentContext';
import { ContentRender } from '../../ContentRender/ContentRender';

const ProductTabsWrapper = styled('div')``;

const HeaderAmount = styled('span')`
  margin-left: 5px;
  &:after {
    content: ')';
  }
  &:before {
    content: '(';
  }
`;

const ProductTabs = ({
  loading,
  product,
  customFields,
  customTabs,
  customData,
}) => {
  const tabsData = [];

  const { descriptionTitle, specificationTitle } =
    useContext(SiteContentContext);

  //DESCRIPTION
  tabsData.push({
    header: descriptionTitle,
    id: 'descr',
    body: <ProductDescription product={product} />,
  });

  //SPECIFICATIONS
  if (customFields && customFields.length) {
    tabsData.push({
      header: specificationTitle,
      id: 'spec',
      body: <ProductSpecificationsWrapper fields={customFields} />,
    });
  }

  //CUSTOM TABS
  if (customTabs && customTabs.length) {
    customTabs.forEach(function (tab, index) {
      //GET PAGE
      if (tab.getPage) {
        tabsData.push({
          header: tab.title,
          id: tab.key,
          body: (
            <PageContent pageId={tab.pageId}>
              {(page) => (
                <>
                  <ContentRender data={page?.data} />
                  <TextContent
                    className="custom-tab-page"
                    content={page?.content}
                  />
                </>
              )}
            </PageContent>
          ),
        });

        //GET STARTPAGE
      } else if (tab.getStartPage) {
        tabsData.push({
          header: tab.title,
          id: tab.key,
          body: <GetStartPage startPageId={tab.pageId} />,
        });
      }

      //SHOW FIELD DATA
      else {
        tabsData.push({
          header:
            tab.listValues && tab.listValues.length ? (
              <span>
                {tab.title}
                <HeaderAmount className="amount">
                  {tab.listValues.length}
                </HeaderAmount>
              </span>
            ) : (
              tab.title
            ),
          id: 'custom' + tab.key,
          body: <TabData data={tab} />,
        });
      }
    });
  }

  //BRAND TABS
  const brandCat =
    product.categories &&
    product.categories.filter(
      (item) => item?.parent?.id === config.routes.brand.id
    )[0];

  if (brandCat) {
    tabsData.push({
      header: brandCat.name,
      id: 'brand',
      body: <BrandTab id={brandCat.id} />,
    });
  }

  return (
    <ProductTabsWrapper id="product-tabs-wrapper">
      <MobileDrops tabsData={tabsData} />
    </ProductTabsWrapper>
  );
};
export default ProductTabs;
